module.exports = __webpack_public_path__ + "assets/img/21_59_big.9884080f.jpg";